export default __webpack_public_path__ + "static/media/background2.f29a2246.jpeg";